<template>
  <div class="card">
    <div class="card-header pt-3 text-center">
      <i class="fa-solid fa-plug"></i>
      <span class="h5">
        {{ circuitData.alias }}
      </span>
    </div>
    <div id="chart-inside" class="card-body">
      <div style="height: 30vh" class="col-6" v-if="time_format === 'day'">
        <canvas :id="`electricCurrentChart${circuitData.id}`"></canvas>
      </div>
      <div style="height: 30vh" class="col-6" v-if="time_format === 'day'">
        <canvas :id="`cumulativeChart${circuitData.id}`"></canvas>
      </div>
      <div style="height: 30vh" class="col-12 d-flex" v-else>
        <canvas ref="myCanvas" :id="`cumulativeChart${circuitData.id}`"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import electricCurrentChart from '../library/electricCurrentChart';
import cumulativeChart from '../library/cumulativeChart';

export default {
  props: ['circuitData'],
  data() {
    return {
      chart_id: '',
    }
  },
  computed: {
    time_format() {
      return this.$store.getters.historicalDataTimeFormat;
    },
    request_date() {
      return this.$store.getters.requestDate;
    },
    circuit() {
      return this.$props.circuitData;
    }
  },
  watch: {
    time_format() {
      this.getBxLog();
    },
    request_date() {
      this.getBxLog();
    }
  },
  methods: {
    getBxLog() {
      this.cancelRequests();
      if (this.time_format === 'day') {
        electricCurrentChart(this.circuit.electricity_data, this.circuit.id);
      }
      cumulativeChart(this.circuit.cumulative_data, this.time_format, this.circuit.id);
    },
    cancelRequests() {
      if (window["myElectricCurrentChart" + this.circuit.id]) {
        window["myElectricCurrentChart" + this.circuit.id].destroy();
      }
      if (window["myCumulativeChart" + this.circuit.id]) {
        window["myCumulativeChart" + this.circuit.id].destroy();
      }
    },
    getCanvasContent() {
      const canvas = this.$refs.myCanvas;
      const content = canvas.toDataURL('image/png');
      this.$store.commit('setCanvasContent', {
        channelId: this.circuit.id,
        content: content,
      });
    },
  },
  mounted() {
    this.getBxLog()
  },
}
</script>
<style>
#chart-inside {
  display: block;
  padding: 0;
}

#chart-inside>.col-6 {
  max-width: 100%;
  padding: 0;
}

@media (min-width: 992px) {
  #chart-inside>.col-6 {
    max-width: 50%;
  }

  #chart-inside {
    display: flex;
  }
}

@media (min-width: 768px) {
  #chart-inside {
    padding: 1.25rem;
  }
}
</style>
